<template>
	<header class="app-header navbar">
	    <button class="navbar-toggler sidebar-toggler d-lg-none mr-auto" type="button" data-toggle="sidebar-show">
	      <span class="navbar-toggler-icon"></span>
	    </button>

	    <router-link :to="{ name: 'home' }" class="navbar-brand"></router-link>

	    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" data-toggle="sidebar-lg-show">
	      <span class="navbar-toggler-icon"></span>
	    </button>

	    <search-bar></search-bar>
	    
	    <user-bar></user-bar>
	</header>
</template>

<script>
	import SearchBar from './SearchBar';
	import UserBar from './UserBar';

	export default {
		components: {
			SearchBar,
			UserBar,
		}
	}
</script>